var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "text-secondary align-self-stretch flex-fill d-flex align-items-center justify-content-center",
    },
    [_c("h6", [_vm._v(_vm._s(_vm.message))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }